"use strict";

var _defineProperty = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _taggedTemplateLiteral = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _excluded = ["children", "order", "sticky"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importStar(require("react"));

var functions_1 = require("../../core/functions");

var index_1 = require("../../index");

var BoxSC = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-self: ", ";\n  flex-direction: ", ";\n  width: 100%;\n\n  div:not(.grid) > & {\n    margin-bottom: ", ";\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n  }\n\n  div.grid + & {\n    margin-top: ", ";\n  }\n\n  ", "\n"])), function (props) {
  return !props.self && !props.alignSelf && 'auto';
}, function (props) {
  return !props.direction && !props.flexDirection && 'column';
}, function (props) {
  return props && props.theme && props.theme.spacing && props.theme.defaultSpace ? props.theme.spacing[props.theme.defaultSpace] : '0';
}, function (props) {
  return props && props.theme && props.theme.spacing && props.theme.defaultSpace ? props.theme.spacing[props.theme.defaultSpace] : '0';
}, functions_1.createStyles);

var Box = function Box(_ref) {
  var children = _ref.children,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? 0 : _ref$order,
      sticky = _ref.sticky,
      props = _objectWithoutProperties(_ref, _excluded);

  var _ref2 = (0, react_1.useContext)(index_1.FormidableContext),
      sc = _ref2.sc;

  return react_1.default.createElement(BoxSC, _objectSpread({
    as: sc && sc.box,
    order: order
  }, props), sticky ? react_1.default.createElement("div", {
    className: "sticky top-".concat(sticky)
  }, children) : children);
};

exports.default = Box;